export const SIDEBAR_ATTACHED_BREAKPOINT = 1440
export const CONTENT_ATTACHED_BREAKPOINT = 768
export const FAVICON_PATH = `${process.env.PUBLIC_URL}/favicon.png`
export const MESSAGES_PER_PAGE = 100
export const STARTER_MESSAGE = /\/start/m
